module.exports = __webpack_public_path__ + "static/media/loaf-transparent.d38956d2.svg";